import { Category } from '@spartacus/core';
import { Observable } from 'rxjs';

export abstract class CategoryAdapter {
  abstract load(catalogId: string, catalogVersionId: string, categoryId: string): Observable<Category>;
}
